// extracted by mini-css-extract-plugin
export default {"container":"styles_container__wtZoh","image":"styles_image__JbCYa","forgotPasswordText":"styles_forgotPasswordText__t71-a","resetLink":"styles_resetLink__lUErx"};